/* eslint-disable react/jsx-no-useless-fragment */
import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslator } from '@front-activerse/common-components';
import { Helmet } from 'react-helmet';
import { Col, Container, Row } from 'reactstrap';
import ExternalProviderContainer from '../ExternalProvider/ExternalProviderContainer';
import { RETURN_URL_LOGIN } from '../ExternalProvider/ReturnUrls';
import AuthLoginByEmailAndPasswordForm from './AuthLoginByEmailAndPasswordForm';
import Layout from '../../Layout/Layout';

const AuthLoginByEmailAndPasswordContainer = ({
  login,
  isLoggedIn,
  userDataOnDemand,
  redirectToPathAfterSuccess,
  displayAppleButton,
  displayFacebookButton,
  displayGoogleButton,
  registerButtonURL,
  action,
}) => {
  const navigate = useNavigate();

  const { t } = useTranslator();

  useEffect(() => {
    if (isLoggedIn) {
      navigate(redirectToPathAfterSuccess);
    }
  }, [isLoggedIn, navigate, redirectToPathAfterSuccess]);

  return (
    <Layout simpleLayout>
      {!isLoggedIn && (
        <>
          <Helmet>
            <meta name="robots" content="noindex,nofollow" />
          </Helmet>
          <div className="page-template-auth full-height7">
            <Container className="py-xxl">
              <Row>
                <Col
                  xs={12}
                  md={{ size: 8, offset: 2 }}
                  xl={{ size: 6, offset: 3 }}
                  xxl={{ size: 4, offset: 4 }}
                >
                  <h1 className="text-center title-medium semi-bold mb-xl">{t('logIn.title')}</h1>

                  <div className="page-container">
                    <div className="auth-container">
                      <ExternalProviderContainer
                        returnUrl={RETURN_URL_LOGIN}
                        displayAppleButton={displayAppleButton}
                        displayFacebookButton={displayFacebookButton}
                        displayGoogleButton={displayGoogleButton}
                        fullWidth
                        action={action}
                      />

                      {(displayAppleButton || displayFacebookButton || displayGoogleButton) && (
                        <div className="line">
                          <span>{t('authorization.continueWithEmail.description')}</span>
                        </div>
                      )}

                      <AuthLoginByEmailAndPasswordForm
                        login={login}
                        userDataOnDemand={userDataOnDemand}
                        redirectToPathAfterSuccess={redirectToPathAfterSuccess}
                      />
                    </div>
                  </div>
                  {registerButtonURL && (
                    <p className="mt-xl text-center">
                      {t('authorization.dontHaveAnAccount')}{' '}
                      <Link to={registerButtonURL}>{t('authorization.signUp.button')}</Link>
                    </p>
                  )}
                </Col>
              </Row>
            </Container>
          </div>
        </>
      )}
    </Layout>
  );
};

AuthLoginByEmailAndPasswordContainer.propTypes = {
  login: PropTypes.func.isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
  userDataOnDemand: PropTypes.func.isRequired,
  redirectToPathAfterSuccess: PropTypes.string.isRequired,
};

export default AuthLoginByEmailAndPasswordContainer;
